import { connect } from 'react-redux'
import { selectModalProps } from 'selectors/modals'
import Modal from './view'

const select = state => ({
  modalProps: selectModalProps(state),
})

export default connect(select, null, null, { forwardRef: true })(Modal)
